export default __webpack_public_path__ + "static/media/report-bg-xl.71f3a0f3.png";